/**
 * Formatter compatto per valori monetari da usare nelle KPICard.
 * Abbrevia i valori grandi per evitare il wrapping in card strette:
 *   ≥1.000.000 → "1,1M €"
 *   ≥1.000     → "110K €"
 *   <1.000     → "850 €"
 */
export function formatKpiEur(value: number): string {
  const abs = Math.abs(value)
  const sign = value < 0 ? '-' : ''

  if (abs >= 1_000_000) {
    const m = abs / 1_000_000
    const formatted = m % 1 === 0
      ? m.toLocaleString('it-IT', { maximumFractionDigits: 0 })
      : m.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    return `${sign}${formatted}M €`
  }

  if (abs >= 10_000) {
    const k = abs / 1_000
    const formatted = k % 1 === 0
      ? k.toLocaleString('it-IT', { maximumFractionDigits: 0 })
      : k.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 1 })
    return `${sign}${formatted}K €`
  }

  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value)
}
